'use strict';

;(function ($) {
  'use strict';

  /**
   * _eachCollFilter - adds fitler key and values to tagList
   * @param  {Element} el     - select element we are stealing the selected options from.
   * @param  {Array} tagList  - array that's getting built
   */

  var _eachCollFilter = function _eachCollFilter(el, tagList) {
    var $self = $(el);
    $self.find('input[type="checkbox"]').filter(':checked').each(function () {
      var $_self = $(this);
      var filterName = $_self.attr('name');
      if (!!filterName) {
        if (!tagList[filterName]) {
          tagList[filterName] = [];
        }
        tagList[filterName].push(_returnValue(this));
      }
    });
  };

  /**
   * [_returnValue description]
   * @param  {Element} el element passed in
   * @return {String}    return the element value
   */
  var _returnValue = function _returnValue(el) {
    if (el.value) {
      return el.value;
    }
    return '';
  };

  /**
   * compare_tags - Compare Selected Tags vs Product Tags
   * @param  {Array} prod_tags       product attribute to check
   * @param  {Array} selected_tags   array of the selected filters
   * @return {Boolean}               true if the tag was found
   */
  var compare_tags = function compare_tags(prod_tags, selected_tags, type) {
    if (!type) {
      type = 'or';
    }

    var _compareFn = function _compareFn(tagName) {
      if (tagName === 'price') {
        return true;
      }

      var selectedValues = selected_tags[tagName];
      if (!!prod_tags[tagName]) {
        var _found = false;
        _found = selectedValues.some(function (selected_value) {
          return !!~prod_tags[tagName].indexOf(selected_value);
        });
        return _found;
      }
      return false;
    };
    var selectedTagsKeys = Object.keys(selected_tags);
    var found_tags = type === 'and' ? selectedTagsKeys.every(_compareFn) : selectedTagsKeys.find(_compareFn);
    return !!found_tags;
  };

  /**
   * compare_price - prices against the selected price filter
   * @param  {Array} price_array - an Array of values (assumed to be strings) the represent product prices
   * @param  {Array} price_tags  - an Array of the selected price filter(s)
   * @return {Boolean}   whether or not a price falls within the range or is greater than (depending on the type of fitler) the currently selected fitlers.
   */
  var compare_price = function compare_price(price_array, price_tags) {
    var removeNonDigitsKeepDecimals = function removeNonDigitsKeepDecimals(string) {
      return string.replace(/[^\d.]/g, '');
    };

    var price_match = price_tags.find(function (price_tag) {
      var priceRange = [];
      if (!!~price_tag.indexOf('-')) {
        priceRange = price_tag.split('-').map(function (num) {
          num = removeNonDigitsKeepDecimals(num);
          return Number(num);
        });
      } else if (!!~price_tag.indexOf('+')) {
        price_tag = removeNonDigitsKeepDecimals(price_tag);
        priceRange = [Number(price_tag), window.Infinity];
      } else {
        priceRange = price_array;
      }

      var min = Math.min.apply(Math, priceRange),
          max = Math.max.apply(Math, priceRange);

      return price_array.find(function (_price) {
        var price = removeNonDigitsKeepDecimals(_price);
        var priceNum = Number(price);
        return priceNum >= min && priceNum <= max;
      });
    });
    return !!price_match;
  };

  /**
   * getGueryParameters - turns the URL query parameters into a usable JavaScript Object.
   * @param  {String} str - optional string value or window.location.search
   * @return {Object}     URL parameters represented as key value pair simple object.
   */
  var getGueryParameters = function getGueryParameters(str) {
    return (str || window.location.search).replace(/(^\?)/, '').split("&").map(function(n) {
      var n = n.split("=");
      if(!this[n[0]]){
        this[n[0]] = [n[1]];
      }
      else {
       this[n[0]].push(n[1]);
      }

      return this;
    }.bind({}))[0];
  };

  /**
   * [_ajaxProducts description]
   * @param  {[type]} num_tags_selected [description]
   * @param  {[type]} selected_tags     [description]
   * @return {[type]}                   [description]
   */
  var _ajaxProducts = function _ajaxProducts(num_tags_selected, selected_tags, moreProducts, pageNum) {
    var moneyFormat = $('#money_format').val().replace('0.00', '');
    var loadProducts = !!moreProducts && moreProducts.length > 0 ? moreProducts : [];
    var allTags = [];
    var store_url_ary = ['https://'+window.Shopify.shop, '', '/products.json'];
    if(!!window.pix.collection_handle){
      store_url_ary[1] = '/collections/'+window.pix.collection_handle;
    }
    var sendAjax = store_url_ary.join('');
    var queryParams = getGueryParameters();

    var maxPage = 3; //parseFloat($('#pagination a:nth-last-child(2)').text());
    /*if(isNaN(maxPage)){
      maxPage = 3;
    }*/

    if (!queryParams.limit) {
      queryParams.limit = '250';
    }
    queryParams.view = 'data';
    if(!pageNum){
      pageNum = 1;
    }
    queryParams.page = pageNum;
    /**
     * _thenable
     * IIF that returns the method to be run first on AJAX data return
     * @return {Function} 
     */
    var _thenable = function (numTagsSelected, selectedTags) {
      return function pushToLoadProducts(data) {
        var json = data; //JSON.parse(data);
        var products = json.products;
        //Product Loop
        if (numTagsSelected > 0) {
          products.forEach(function (product) {
            var prodTags = {};

            if (window.pix.useOptions) {
              product.options_with_values.forEach(function (opt) {
                prodTags[opt.name.toLowerCase()] = opt.values; //opt.values is an Array
              });
            }

            if (window.pix.useTags) {
              product.tags.forEach(function(tag, i) {
                if (!!~tag.indexOf('filter_')) {
                  var tagArray = tag.trim().replace('filter_', '').split('_');
                  if (tagArray.length == 2) {
                    //assumes there will always be length of 2
                    var tagName = tagArray[0].toLowerCase(),
                        tagValue = tagArray[1].toLowerCase();
                    if (!prodTags[tagName]) {
                      prodTags[tagName] = [tagValue];
                    } else {
                      prodTags[tagName].push(tagValue);
                    }
                  }
                }
                else {
                  if (!prodTags['tag']) {
                    prodTags['tag'] = [tag];
                  }
                  else {
                    prodTags['tag'].push(tag);
                  }
                }
              });
            }

            if(!!product.vendor){
              var vendor = product.vendor.toLowerCase().replace(/[\W_]+/g, '-');
              if (!prodTags['vendor']) {
                prodTags['vendor'] = [vendor];
              }
              else {
                prodTags['vendor'].push(vendor);
              }
            }

            if(!!product.product_type){
              var product_type = product.product_type.toLowerCase().replace(/[\W_]+/g, '-');
              if (!prodTags['product-types']) {
                prodTags['product-types'] = [product_type];
              }
              else {
                prodTags['product-types'].push(product_type);
              }
            }

            var priceFilter = true;
            if (!!selectedTags.price) {
              var prices = product.variants.map(function (variant) {
                return window.Shopify.formatMoney(variant.price, moneyFormat);
              }).filter(function (price, index, self) {
                return self.indexOf(price) === index;
              });

              priceFilter = compare_price(prices, selectedTags.price);
            }

            var foundTags = !!Object.keys(selectedTags).length ? compare_tags(prodTags, selectedTags, window.pix.filter_type) : true;

            var proceed = window.pix.filter_type === 'or' ? priceFilter || foundTags : priceFilter && foundTags;

            if (proceed) {
              //If matches ANY or ALL (based on window.pix.filter_type) selected product tags, push this product into custom array
              loadProducts.push(product);
              //add the product's options and tags to all tags to disable / enable HTML filter options
              allTags.push(prodTags);
            }
          });
        } else {
          loadProducts = !!products ? products : [];
        }

        // if(products.length > 0 && pageNum < maxPage){
        //   _ajaxProducts(num_tags_selected, selected_tags, loadProducts, pageNum+1);
        // }
      };
    }(num_tags_selected, selected_tags);

    /**
     * [_afterThenable description]
     * @param  {Object} post post data from jQuery Ajax call to Shopify products.json
     */
    var _afterThenable = function _afterThenable() /*post*/{
      var productGrid = $('#productGrid');
      productGrid.empty();
      if (!loadProducts.length) {
        //No Products Found
        var template = '<div class="product-index"><div class="grid__item">' + '<p class="text-left" style="margin-top:40px">Sorry, there are no products found with these parameters. Please change your filter selection.</p>' + '</div></div>';
        //Load No Products message
        productGrid.append(template);
      } else {
        var gridItemMap = [];
        var n = -1;
        var rowCount = 4;

        for (var i = 0; i < loadProducts.length; i++) {
          var remainder = i % rowCount;
          if (remainder === 0) {
            n++;
          }

          var product = loadProducts[i];
          //Load only the products with selected filter tags
          if (!gridItemMap[n]) {
            gridItemMap[n] = [];
          }
          gridItemMap[n].push(_gridItem(product, remainder, n));
        }

        gridItemMap.forEach(function (row, index) {
          productGrid.append(_gridRow(row, index));
        });

        $('#pagination').hide();

        _emitGridComplete(document.querySelector('#productGrid'));

        _toggleFilterOptions(allTags);
      }
    };

    var _gridRow = function _gridRow(gridItems, rowNum) {
      var template = gridItems.join(''); //'<div class="grid grid--uniform grid-view-items grid__items-row-{index}" data-row="{index}">' +  + '</div>';
      return template.replace('{index}', rowNum);
    };

    /**
     * [_gridItem description]
     * @param  {Object} product Shopify product object.
     * @return {String}         string version of HTML, when have time, replace with handlebars template
     */
    var _gridItem = function _gridItem( product, index, rowNum ) {
      var stripHTML = new RegExp(/<{1}[^<>]{1,}>{1}/g);
      var _data = Object.assign({}, product);
      _data.title = product.title;
      _data.grid_item_width = 'small--one-half medium-up--one-quarter';
      _data.row_num = rowNum;
      _data.row_index = index;
      _data.item_class = index === 0 ? ' first' : '';
      _data.enable_quickview = false;
      _data.pdp_link = '/collections/' + window.pix.collection_handle + '/products/' + product.handle; //product url starts with a slash
      _data.image_ph = "//www.anchoring.com/cdn/shop/t/9/assets/lazylogo_650x.png?v=89082857819187196181622568918";
      _data.image_1_src = rebuildImageUrl(product.images[0]);
      _data.image_1_alt = product.title;
      _data.image_2_src = product.images.length > 1 ? rebuildImageUrl(product.images[1]) : '';
      _data.image_2_alt = product.title;
      _data.has_hover_image = product.images.length > 1;
      _data.show_vendor = true;
      _data.price = product.variants[0].price.replace(stripHTML, '');
      var variantPrices = [];
      var variantCompareAtPrices = [];
      var productContainsCompareAtPrice = false;
      var isSoldOut = true;
      for (var i = 0; i < product.variants.length; i++) {
        variantPrices.push(parseFloat(product.variants[i].price));
        variantCompareAtPrices.push(parseFloat(product.variants[i].compare_at_price));
        if (product.variants[i].compare_at_price > 0) {
          productContainsCompareAtPrice = true;
        }
        if (product.variants[i].available == true) {
          isSoldOut = false;
        }
      }
      _data.price_min = Math.min(...variantPrices).toLocaleString('en-US',  {style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 0});
      _data.price_max = (_data.price_min == Math.max(...variantPrices)) ? 0 : Math.max(...variantPrices).toLocaleString('en-US',  {style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 0});
      _data.price_equal = _data.price_min == _data.price_max;
      _data.is_on_sale = productContainsCompareAtPrice;
      _data.sale_text = "Sale";
      _data.is_sold_out = isSoldOut;
      _data.is_sold_out_text = "Sold Out";
      var template = window.pix.templates.gi; //aquire the grid view template
      return template(_data);
    };

    var rebuildImageUrl = function rebuildImageUrl(imgObj) {
      return imgObj.src; //plp specific image size and cropping.
    };

    /**
     * [_toggleFilterOptions description]
     * @param  {Array} arrayOfOpts array of available options per product
     * @return {Array} undefined if filterOptionDisplay visible or no length. Otherwise flat array of objects.
     */
    var _toggleFilterOptions = function _toggleFilterOptions(arrayOfOpts) {
      var allOpts = {};
      var filterOptionDisplay = window.pix.filter_option_display;

      if (filterOptionDisplay === 'visible') {
        return; //if visible, do nothing and return;
      }

      var $_allFakeOpts = $('.filter-item');
      $_allFakeOpts.removeClass('hidden');
      $_allFakeOpts.removeClass('disabled');

      if (!arrayOfOpts.length) {
        var $_options = $('.coll-filter option');
        $_options.removeAttr(filterOptionDisplay);
        $_allFakeOpts.removeClass(filterOptionDisplay);
        return; //if no fitlers selected, show all and return;
      }

      arrayOfOpts.forEach(function (obj) {
        Object.keys(obj).forEach(function (key) {
          if (!allOpts[key]) {
            allOpts[key] = obj[key];
          } else {
            allOpts[key].push.apply(allOpts[key], obj[key]);
          }
        });
      });

      Object.keys(allOpts).forEach(function (filterName) {
        var $filterSelect = $('.coll-filter-' + filterName),
            $options = null,
            $fakeOpts = null,
            filterOpts = allOpts[filterName];

        if ($filterSelect.length) {
          $options = $filterSelect.children('option[data-filter]');
          $fakeOpts = $('[data-filter="' + filterName + '"]');
          if (!loadProducts.length) {
            if (filterOptionDisplay === 'disabled') {
              $options.removeAttr('disabled');
            } else if (filterOptionDisplay === 'hidden') {
              $options.removeClass('hidden');
            }
            $fakeOpts.removeClass(filterOptionDisplay);
          } else {
            $options.each(function () {
              var $this = $(this),
                  value = this.value;

              $fakeOpts = $('[data-filter="' + filterName + '"][data-value="' + value + '"]');

              if (!!~filterOpts.indexOf(value)) {
                if (filterOptionDisplay === 'disabled' || filterOptionDisplay === 'hidden') {
                  $this.removeAttr(filterOptionDisplay);
                  $fakeOpts.removeClass(filterOptionDisplay);
                }
              } else if (value !== '') {
                if (filterOptionDisplay === 'disabled') {
                  $this.attr('disabled', 'disabled');
                } else if (filterOptionDisplay === 'hidden') {
                  $this.addClass('hidden');
                }
                $fakeOpts.addClass(filterOptionDisplay);
              }
            });
          }
        }
      });

      return arrayOfOpts;
    };

    /**
     * [_ajaxFail description]
     * @param  {Object} jqXHR      [description]
     * @param  {String} textStatus [description]
     * @return {Object} Alert box if there is a failure...should make this prettier for user.
     */
    var _ajaxFail = function _ajaxFail(jqXHR, textStatus) {
      console.error(jqXHR);
      return console.error('Request failed: ' + textStatus);
    };

    /**
     * WARNING!
     * DO NOT ADD datatype: 'json' to this request! Shopify WILL return the WRONG data!
     */
    $.ajax({
      url: sendAjax,
      data: queryParams,
      method: 'GET'
    }).then(_thenable).done(_afterThenable).fail(_ajaxFail);
  };

  var _emitGridComplete = function _emitGridComplete(newGrid) {
    if (!window.pix.eventEmitter1.check('gridComplete')) {
      window.pix.eventEmitter1.add('gridComplete');
    }
    window.pix.eventEmitter1.fire('gridComplete', newGrid);
  };

  /**
   * _changeEvent - DOM Event that starts the whole Ajax Filter process
   */
  var _changeEvent = function _changeEvent(e, onPageLoad) {
    if (!!window.Shopify && !!window.Shopify.queryParams) {
      delete window.Shopify.queryParams.page;
    }

    //var newTags = [];
    var selectedTags = {};
    var numTagsSelected = 0;
    var newURL = null;
    var collFilters = $('.coll-filter');

    collFilters.each(function () {
      _eachCollFilter(this, selectedTags);
    });

    numTagsSelected = Object.keys(selectedTags).length;

    // hiding Sort when using filters because Sort uses shopify to fetch products via reload so does not work with js filters
    // unless we were to replicate all sorting functions into js filters 
    if (numTagsSelected) {
      $('#sort_by_select').hide();
    } else {
      $('#sort_by_select').show();
    }

    if (window.pix.collection_handle) {
      newURL = '/collections/' + window.pix.collection_handle;
    } else {
      newURL = '/collections/all/';
    }

    var queryParamsObj = !!onPageLoad ? window.Shopify.queryParams : {};

    var search = jQuery.param($.extend({}, queryParamsObj, selectedTags)).replace(/%5B%5D/g, '');

    if (search.length) {
      newURL += '?' + search;
    }

    if (!!newURL && !!window.history && !!window.history.replaceState) {
      window.history.replaceState(null, null, newURL);
    }

    _ajaxProducts(numTagsSelected, selectedTags);
  };

  /**
   * [_sizeComputeComparable description]
   * @param  {String} value - option value of Size is "NUM1 x NUM2" e.g. "32 x 34"
   * @return {Number}       - Join the 2 string together as 1 number. This is intended for sorting.
   */
  var _sizeComputeComparable = function _sizeComputeComparable(value) {
    return Number(value.replace(' x ', ''));
  };

  /**
   * _runFiltersOnPageLoad - trigger the selected filters to run when the page loads because we can't do that in liquid!
   */
  var _runFiltersOnPageLoad = function _runFiltersOnPageLoad() {
    var urlParams = new URLSearchParams(window.location.search);
    var keys = !!urlParams ? Array.from(urlParams.keys()) : [];
    var values = !!urlParams ? Array.from(urlParams.values()) : [];

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var value = values[i].replace(/\+/g, ' ');
      var filter = document.querySelector('input[name="'+key+'"][value="'+value+'"]');
      if (!!filter) {
        var $filter = $(filter).prop('checked', true);
        $filter.trigger('change', [ true ]);
      }
    }
  };

  /**
   * _closeAllOpenFilters - close all open filters when you click away
   * @param  {Object} e - event object (using e.target)
   */
  var _closeAllOpenFilters = function _closeAllOpenFilters(e) {
    var $styledSelectbox = $(e.target).parents('.styled-selectbox');
    var _focusedSelects = [].slice.call(document.querySelectorAll('.coll-filter'));
    var _focusedLists = [].slice.call(document.querySelectorAll('.styled-selectbox'));

    if ($styledSelectbox.length === 0) {
      _focusedSelects.forEach(function (el) {
        el.classList.remove('focused-select');
      });
      _focusedLists.forEach(function (el) {
        el.classList.remove('focused-list');
      });
    }
  };

  var giTemplateUrl = function () {
    var hiddenInput = document.querySelector('#gi_url');
    return !!hiddenInput ? hiddenInput.value : null;
  }();
  window.pix.loadTemplate('gi', giTemplateUrl);

  document.addEventListener("DOMContentLoaded", function () {

    var collFilters = $('.coll-filter');

    collFilters.on('change', _changeEvent);

    collFilters.on('mousedown', function (e) {
      if ($(window).width() >= window.theme.mobileBreakPoint) {
        e.preventDefault();
        _closeAllOpenFilters(e);
        this.classList.add('focused-select');
        this.nextElementSibling.classList.add('focused-list');
      }
    });

    $('.filter-item').on('click', function (e) {
      if ($(window).width() >= window.theme.mobileBreakPoint) {
        e.preventDefault();

        var filterName = this.getAttribute('data-filter'),
            filterVal = this.getAttribute('data-value'),
            selectbox = null;

        if (!this.classList.contains('blank-option') && (this.classList.contains('disabled') || this.classList.contains('hidden'))) {
          return;
        }
        var siblings = this.parentElement.children;
        for (var skey in siblings) {
          if (siblings.hasOwnProperty(skey)) {
            var sibling = siblings[skey];
            sibling.classList.remove('active-filter');
          }
        }
        this.classList.add('active-filter');
        this.parentElement.parentElement.classList.remove('focused-list');

        selectbox = document.querySelector('#filter_' + filterName);
        if (!!selectbox) {
          selectbox.classList.remove('focused-select');
          selectbox.value = filterVal;
          $(selectbox).trigger('change');
        }
      }
    });

    var pageContainer = document.querySelector('.page-container');
    var siteHeader = document.querySelector('.site-header');

    $(pageContainer).on('click.closeFilters', _closeAllOpenFilters);
    $(siteHeader).on('click.closeFilters', _closeAllOpenFilters);
  });

  $(window).on('load', function () {
    _runFiltersOnPageLoad();
  });
})(jQuery);
//# sourceMappingURL=collection_filters.js.map
